"use client";

import { useTranslations } from "next-intl";
import ContactForm from "@/components/contact/ContactForm";
import ContactMap from "@/components/contact/ContactMap";

export default function ContactSection() {
	const t = useTranslations("ContactSection");

	return (
		<section className="py-20 text-center bg-[#f1f1f1]">
			<div className="w-full section-padding">
				<h3 className="text-[2.8rem] font-normal text-black mb-2">
					{t("title")}
				</h3>
				<p className="text-[1.8rem] text-black mb-20">{t("subtitle")}</p>
				<div className="flex flex-wrap justify-evenly gap-6">
					<div className="px-6 py-4 flex-1 min-w-[32rem]">
						<ContactForm />
					</div>
					<div className="flex-1 min-w-[32rem] min-h-[510px]">
						<ContactMap />
					</div>
				</div>
			</div>
		</section>
	);
}
